(function () {
  if (window.CxGarageApp) return;
  var cfgEl = document.getElementById('CxGarCfg'); if (!cfgEl) return;
  var CFG = {}; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var KEY = 'cx_garage', MAX = 5;
  var CAR_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 16v-1.6c0-.8.5-1.4 1.3-1.6l3.4-.9 2.8-2.5c.5-.4 1.1-.6 1.7-.6h3.6c.8 0 1.5.4 2 1l2 2.3 1.9.4c.8.2 1.3.9 1.3 1.7V16"/><path d="M3 16h2M9 16h6M19 16h2M8.6 12.3h9.6"/><circle cx="7" cy="16" r="2"/><circle cx="17" cy="16" r="2"/></svg>';
  var OK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>';
  var WARN_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 2 20h20L12 3z"/><path d="M12 10v4M12 17.5v.01"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function load() { try { var d = JSON.parse(localStorage.getItem(KEY) || 'null'); if (d && d.cars) return d; } catch (e) {} return { cars: [], a: 0 }; }
  function save(d) { try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} }
  function low(a) { return (a || []).map(function (x) { return String(x).toLowerCase(); }); }
  function pageFor(c) {
    var ps = CFG.pages || [];
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (p.b && p.b !== c.b) continue;
      if (p.m && p.m !== c.m) continue;
      if (p.g && (!c.g || p.g.indexOf(c.g) < 0)) continue;
      if (!p.b && !p.m && !p.g) continue;
      return p.h;
    }
    return null;
  }
  function carName(c) { return [c.b, c.m, c.g].filter(Boolean).join(' '); }
  function shortName(c) { return c.g ? (c.m && c.g.indexOf(c.m) < 0 && c.m.length < 10 ? c.m + ' ' + c.g : c.g) : c.m; }
  function carUrl(c) { var h = pageFor(c); if (h) return '/collections/' + h; return '/search?type=product&q=' + encodeURIComponent(carName(c)); }
  function active() { var d = load(); return d.cars[d.a] || d.cars[0] || null; }
  function fit(prod, c) {
    if (!prod || !c) return null;
    if (prod.u) return 'uni';
    var b = low(prod.b), m = low(prod.m), g = low(prod.g);
    if (b.length && b.indexOf(c.b.toLowerCase()) < 0) return 'no';
    if (!b.length && !m.length && !g.length) return 'unknown';
    if (c.g && g.length) return g.indexOf(c.g.toLowerCase()) >= 0 ? 'yes' : 'no';
    if (c.m && m.length) {
      if (m.indexOf(c.m.toLowerCase()) < 0) return 'no';
      return c.g ? 'maybe' : 'yes';
    }
    if (c.g && !g.length && !m.length) return 'maybe';
    return b.length ? 'maybe' : 'unknown';
  }

  /* ---------- Garaje (escena) ---------- */
  var root = document.getElementById('CxGarage');
  if (root && root.parentNode !== document.body) document.body.appendChild(root);
  var $ = function (q) { return root.querySelector(q); };
  var shEl = $('[data-cxg-sh]'), dotsEl = $('[data-cxg-dots]'), cntEl = $('[data-cxg-cnt]'), carEl = $('[data-cxg-car]'), infoEl = $('[data-cxg-info]');
  var sideL = $('[data-cxg-l]'), sideR = $('[data-cxg-r]'), prevB = $('[data-cxg-prev]'), nextB = $('[data-cxg-next]');
  var form = $('[data-cxg-form]'), sb = $('[data-cxg-b]'), sm = $('[data-cxg-m]'), sg = $('[data-cxg-g]'), sv = $('[data-cxg-save]');
  var VEH = null, lastFocus = null, view = 0;
  var GHOST = '<span class="cxg__ghost">' + CAR_SVG + '</span>';
  var IMGL = false;
  function loadImgs() { if (IMGL) return; IMGL = true; fetch(CFG.gimg).then(function (r) { return r.json(); }).then(function (j) { CFG.imgs = j.imgs || {}; CFG.gimgs = j.gimgs || []; if (!root.hidden) render(); }).catch(function () { CFG.imgs = {}; CFG.gimgs = []; }); }
  function imgOf(c) {
    if (!CFG.imgs && CFG.gimg) { loadImgs(); return ''; }
    var h = pageFor(c); if (h && CFG.imgs && CFG.imgs[h]) return CFG.imgs[h];
    var G = (CFG.gimgs || []).filter(function (r) { return r && r[0] === c.b && r[1] === c.m; });
    if (!G.length) return '';
    var x = (c.g && G.filter(function (r) { return r[2] === c.g; })[0]) || G.filter(function (r) { return !r[2]; })[0];
    if (!x && !c.g && G.every(function (r) { return r[3] === G[0][3]; })) x = G[0];
    return x ? x[3] : '';
  }
  function carHTML(c) { var im = imgOf(c); return im ? '<img src="' + esc(im) + '" alt="' + esc(carName(c)) + '">' : GHOST; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function loadVeh(cb) {
    if (VEH) return cb();
    fetch(CFG.vehicles).then(function (r) { return r.json(); }).then(function (j) { VEH = j; cb(); }).catch(function () { VEH = {}; cb(); });
  }
  function opt(sel, items, first) { sel.innerHTML = '<option value="">' + first + '</option>' + items.map(function (x) { return '<option value="' + esc(x) + '">' + esc(x) + '</option>'; }).join(''); }
  function fillBrands() { opt(sb, Object.keys(VEH).sort(function (a, b) { return a.localeCompare(b, 'es'); }), 'Elige marca'); opt(sm, [], 'Elige modelo'); opt(sg, [], 'Todas'); sm.disabled = true; sg.disabled = true; sv.disabled = true; }
  sb.addEventListener('change', function () {
    var ms = VEH[sb.value] ? Object.keys(VEH[sb.value]).sort(function (a, b) { return a.localeCompare(b, 'es', { numeric: true }); }) : [];
    opt(sm, ms, 'Elige modelo'); sm.disabled = !ms.length; opt(sg, [], 'Todas'); sg.disabled = true; sv.disabled = true;
  });
  sm.addEventListener('change', function () {
    var gs = (VEH[sb.value] && VEH[sb.value][sm.value]) || [];
    opt(sg, gs, gs.length ? 'Todas las generaciones' : 'Todas'); sg.disabled = !gs.length; sv.disabled = !sm.value;
  });
  function showForm() { if (load().cars.length >= MAX) return; form.hidden = false; loadVeh(fillBrands); setTimeout(function () { sb.focus(); }, 50); }
  function hideForm() { form.hidden = true; }
  $('[data-cxg-cancel]').addEventListener('click', hideForm);
  form.addEventListener('submit', function () {
    if (!sb.value || !sm.value) return;
    var c = { b: sb.value, m: sm.value, g: sg.value || '' };
    hideForm(); add(c, true);
  });
  function add(c, fromScene) {
    var d = load();
    var k = carName(c).toLowerCase();
    var ix = -1; d.cars.forEach(function (x, i) { if (carName(x).toLowerCase() === k) ix = i; });
    if (ix < 0) { if (d.cars.length >= MAX) d.cars.pop(); d.cars.push(c); ix = d.cars.length - 1; }
    d.a = ix; save(d); view = ix;
    if (fromScene && !root.hidden) { render('is-park'); setTimeout(function () { refresh(true); }, 1300); } else refresh(true);
  }
  function render(anim) {
    var d = load(), cars = d.cars, n = cars.length;
    if (view >= n) view = Math.max(0, d.a);
    var sh = '';
    for (var i = 0; i < MAX; i++) {
      var cl = i < n ? '' : ' is-closed';
      if (i === view && n) cl += ' is-on';
      sh += '<div class="cxg__shut' + cl + '"' + (i < n ? '' : ' data-cxg-addopen role="button" tabindex="0" aria-label="Aparcar un coche"') + '><i>' + pad(i + 1) + '</i>' + (i < n ? '' : '<span>+ Aparcar</span>') + '</div>';
    }
    shEl.innerHTML = sh;
    dotsEl.innerHTML = Array.apply(null, Array(MAX)).map(function (x, i) { return '<i class="' + (i === view && n ? 'is-on' : i < n ? 'is-f' : '') + '"></i>'; }).join('');
    cntEl.textContent = n + ' / ' + MAX;
    if (!n) {
      carEl.className = 'cxg__car'; carEl.innerHTML = GHOST;
      infoEl.innerHTML = '<small>Plaza 01 · Libre</small><strong>Tu garaje está vacío</strong><div class="cxg__btns"><button type="button" class="is-main" data-cxg-addopen>+ Aparcar mi coche</button></div>';
      sideL.hidden = sideR.hidden = prevB.hidden = nextB.hidden = true;
      return;
    }
    var c = cars[view];
    carEl.className = 'cxg__car'; carEl.innerHTML = carHTML(c);
    if (anim) { void carEl.offsetWidth; carEl.classList.add(anim); }
    var isA = view === d.a;
    infoEl.innerHTML = '<small>' + esc(c.b) + ' · Plaza ' + pad(view + 1) + (isA ? ' · Coche activo' : '') + '</small><strong>' + esc([c.m, c.g].filter(Boolean).join(' ')) + '</strong>' +
      '<div class="cxg__btns">' + (isA ? '<a class="is-main" href="' + esc(carUrl(c)) + '">Ver piezas para mi ' + esc(shortName(c)) + ' →</a>' + (n < MAX ? '<button type="button" data-cxg-addopen>+ Aparcar otro coche</button>' : '')
        : '<button type="button" class="is-main" data-cxg-use>Usar este coche</button><a href="' + esc(carUrl(c)) + '">Ver sus piezas →</a>') + '</div>' +
      '<button type="button" class="cxg__del" data-cxg-del>Sacar del garaje</button>';
    var L = n > 1 ? cars[(view - 1 + n) % n] : null, R = n > 2 ? cars[(view + 1) % n] : (n === 2 ? null : null);
    if (n === 2) { R = cars[(view + 1) % n]; L = null; }
    sideL.hidden = !L; sideR.hidden = !R;
    if (L) sideL.innerHTML = carHTML(L) + '<b>' + esc(carName(L)) + '</b><small>Plaza ' + pad(((view - 1 + n) % n) + 1) + '</small>';
    if (R) sideR.innerHTML = carHTML(R) + '<b>' + esc(carName(R)) + '</b><small>Plaza ' + pad(((view + 1) % n) + 1) + '</small>';
    prevB.hidden = nextB.hidden = n < 2;
  }
  function go(dir) { var n = load().cars.length; if (n < 2) return; view = (view + dir + n) % n; render(dir > 0 ? 'is-in-r' : 'is-in-l'); }
  prevB.addEventListener('click', function () { go(-1); });
  nextB.addEventListener('click', function () { go(1); });
  sideL.addEventListener('click', function () { go(-1); });
  sideR.addEventListener('click', function () { go(1); });
  var tx = null;
  root.addEventListener('touchstart', function (e) { if (!form.hidden) return; tx = e.touches[0].clientX; }, { passive: true });
  root.addEventListener('touchend', function (e) { if (tx == null) return; var dx = e.changedTouches[0].clientX - tx; tx = null; if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1); }, { passive: true });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cxg-close]')) return close();
    if (e.target.closest('[data-cxg-addopen]')) return showForm();
    if (e.target.closest('[data-cxg-use]')) { var d = load(); d.a = view; save(d); render(); refresh(true); return; }
    if (e.target.closest('[data-cxg-del]')) { var d2 = load(); d2.cars.splice(view, 1); if (d2.a >= d2.cars.length || d2.a === view) d2.a = 0; else if (view < d2.a) d2.a--; save(d2); view = d2.a; render('is-in-l'); refresh(true); }
  });
  root.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft' && form.hidden) go(-1); if (e.key === 'ArrowRight' && form.hidden) go(1); if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-cxg-addopen]')) { e.preventDefault(); showForm(); } });
  function open() { lastFocus = document.activeElement; view = load().a || 0; root.hidden = false; document.documentElement.style.overflow = 'hidden'; render('is-park'); if (!load().cars.length) showForm(); else hideForm(); var x = $('.cxg__x'); if (x) x.focus(); }
  function close() { root.hidden = true; hideForm(); document.documentElement.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) { if (!form.hidden) hideForm(); else close(); } });
  document.addEventListener('click', function (e) { var t = e.target.closest('[data-cxg-open]'); if (t && !root.contains(t)) { e.preventDefault(); open(); } });

  /* ---------- Cabecera y menú ---------- */
  function header() {
    var a = active();
    document.querySelectorAll('.cx-mco-icon').forEach(function (ic) {
      ic.setAttribute('data-cxg-open', '');
      var dot = ic.querySelector('.cx-mco-dot');
      if (a && !dot) { dot = document.createElement('span'); dot.className = 'cx-mco-dot'; ic.appendChild(dot); }
      if (!a && dot) dot.remove();
      ic.setAttribute('aria-label', a ? 'Mi garaje: ' + carName(a) : 'Mi garaje: guarda tu coche');
    });
    var w = document.querySelector('[data-mco-last]'), la = document.querySelector('[data-mco-last-a]');
    if (w && la) {
      if (a) { w.hidden = false; w.firstElementChild.textContent = 'Tu coche:'; la.href = carUrl(a); la.textContent = carName(a); }
      var btn = w.querySelector('[data-cxg-open]');
      if (!btn) { btn = document.createElement('button'); btn.type = 'button'; btn.setAttribute('data-cxg-open', ''); btn.style.cssText = 'margin-left:auto;border:0;background:none;font:700 13px var(--cx-font-body);color:#1d6a0c;text-decoration:underline;cursor:pointer'; w.appendChild(btn); }
      btn.textContent = a ? 'Mi garaje' : 'Guardar mi coche';
      if (!a) { w.hidden = false; w.firstElementChild.textContent = 'Guarda tu coche y te enseñamos solo lo que le vale.'; la.textContent = ''; }
    }
  }

  /* ---------- Ficha de producto ---------- */
  function product() {
    var box = document.querySelector('.cx-gfit'); if (box) box.remove();
    if (CFG.page !== 'product' || !CFG.product) return;
    var a = active(), host = document.querySelector('.cx-pdp__compat') || document.querySelector('.cx-pdp__price');
    if (!host) return;
    var el = document.createElement('div');
    if (!a) {
      el.className = 'cx-gfit cx-gfit--maybe'; el.style.background = '#f6f6f4'; el.style.borderColor = '#e6e6e3'; el.style.color = '#3a3a37';
      el.innerHTML = CAR_SVG + '<span>¿Vale para tu coche? <b>Guárdalo en Mi garaje</b> y te lo decimos al momento.</span><button type="button" data-cxg-open>Guardar</button>';
    } else {
      var f = fit(CFG.product, a), nm = esc(carName(a));
      if (f === 'yes' || f === 'uni') { el.className = 'cx-gfit cx-gfit--ok'; el.innerHTML = OK_SVG + '<span>' + (f === 'uni' ? 'Pieza universal: <b>vale para tu ' + nm + '</b>' : '<b>Vale para tu ' + nm + '</b>') + '</span><button type="button" data-cxg-open>Cambiar</button>'; }
      else if (f === 'maybe' || f === 'unknown') { el.className = 'cx-gfit cx-gfit--maybe'; el.innerHTML = WARN_SVG + '<span>Puede valer para tu <b>' + nm + '</b>, pero confírmanos la versión por WhatsApp antes de comprar.</span><button type="button" data-cxg-open>Cambiar</button>'; }
      else { el.className = 'cx-gfit cx-gfit--no'; el.innerHTML = WARN_SVG + '<span><b>No consta que valga para tu ' + nm + '.</b> <a href="' + esc(carUrl(a)) + '">Ver piezas para tu ' + esc(shortName(a)) + '</a></span><button type="button" data-cxg-open>Cambiar</button>'; }
    }
    if (host.classList.contains('cx-pdp__compat')) host.insertBefore(el, host.firstChild); else host.parentNode.insertBefore(el, host.nextSibling);
  }

  /* ---------- Tarjetas ---------- */
  function cards(scope) {
    var a = active(); if (!a) { document.querySelectorAll('.cx-badge--fit').forEach(function (b) { b.remove(); }); return; }
    (scope || document).querySelectorAll('.cx-card[data-cx-fit]').forEach(function (card) {
      var old = card.querySelector('.cx-badge--fit'); if (old) old.remove();
      var p; try { p = JSON.parse(card.getAttribute('data-cx-fit')); } catch (e) { return; }
      var f = fit(p, a);
      if (f === 'yes' || f === 'uni') {
        var bx = card.querySelector('.cx-card__badges'); if (!bx) return;
        var s = document.createElement('span'); s.className = 'cx-badge cx-badge--fit'; s.textContent = '✓ Para tu ' + (a.g || a.m); s.title = 'Vale para tu ' + carName(a);
        bx.insertBefore(s, bx.firstChild);
      }
    });
  }

  /* ---------- Listados ---------- */
  function filterParams(c, f) {
    var pb = 'filter.p.m.compatibilidad.marca', pm = 'filter.p.m.compatibilidad.modelo', pg = 'filter.p.m.compatibilidad.generacion';
    if (!f[pb] || f[pb].indexOf(c.b) < 0) return null;
    var q = [[pb, c.b]];
    if (c.g && f[pg] && f[pg].indexOf(c.g) >= 0) q.push([pg, c.g]);
    else if (c.m && f[pm] && f[pm].indexOf(c.m) >= 0) q.push([pm, c.m]);
    else if (c.g || c.m) return null;
    return q;
  }
  function listing() {
    var bar = document.querySelector('.cx-gbar'); if (bar) bar.remove();
    var co = CFG.coll; if (!co) return;
    var a = active(); if (!a) return;
    var host = document.querySelector('.cx-cg__bar');
    if (!host) {
      var sec = document.querySelector('#MainContent > .shopify-section'); if (!sec) return;
      var wrap = document.querySelector('.cx-gbar-wrap');
      if (!wrap) { wrap = document.createElement('div'); wrap.className = 'cx-wrap cx-gbar-wrap'; wrap.style.paddingTop = '16px'; var anc = document.querySelector('.cx-col__hero') || sec; anc.parentNode.insertBefore(wrap, anc.nextSibling); wrap.appendChild(document.createElement('span')); }
      host = wrap.lastChild;
    }
    var url = new URL(location.href), offKey = 'cx_gar_off_' + co.h, nm = esc(shortName(a));
    var hasF = Object.keys(co.f).length > 1;
    var mine = hasF ? filterParams(a, co.f) : null;
    var isMine = mine && mine.every(function (kv) { return url.searchParams.getAll(kv[0]).indexOf(kv[1]) >= 0; });
    var off = false; try { off = sessionStorage.getItem(offKey) === '1'; } catch (e) {}
    if (mine && !isMine && !co.active && !off && !url.searchParams.has('cxg_off')) {
      mine.forEach(function (kv) { url.searchParams.append(kv[0], kv[1]); });
      location.replace(url.toString()); return;
    }
    var el = document.createElement('div'); el.className = 'cx-gbar';
    var ic = '<span class="cx-gbar__ic">' + CAR_SVG + '</span>';
    if (isMine) {
      var all = new URL(location.href); mine.forEach(function (kv) { var vs = all.searchParams.getAll(kv[0]).filter(function (v) { return v !== kv[1]; }); all.searchParams.delete(kv[0]); vs.forEach(function (v) { all.searchParams.append(kv[0], v); }); });
      el.innerHTML = ic + '<span class="cx-gbar__t">Mostrando solo piezas para tu <b>' + esc(carName(a)) + '</b></span><a href="' + esc(all.toString()) + '" data-cxg-all>Ver todo</a><button type="button" data-cxg-open>Cambiar coche</button>';
      el.querySelector('[data-cxg-all]').addEventListener('click', function () { try { sessionStorage.setItem(offKey, '1'); } catch (e) {} });
    } else if (hasF && !mine) {
      el.innerHTML = ic + '<span class="cx-gbar__t">En esta sección no tenemos piezas registradas para tu <b>' + esc(carName(a)) + '</b>.</span><a class="is-main" href="' + esc(carUrl(a)) + '">Ver piezas para tu ' + nm + '</a>';
    } else if (mine) {
      var u2 = new URL(location.href); mine.forEach(function (kv) { u2.searchParams.append(kv[0], kv[1]); });
      el.innerHTML = ic + '<span class="cx-gbar__t">¿Ver solo lo que vale para tu <b>' + esc(carName(a)) + '</b>?</span><a class="is-main" href="' + esc(u2.toString()) + '" data-cxg-on>Filtrar por mi coche</a>';
      el.querySelector('[data-cxg-on]').addEventListener('click', function () { try { sessionStorage.removeItem(offKey); } catch (e) {} });
    } else {
      el.innerHTML = ic + '<span class="cx-gbar__t">Tu coche: <b>' + esc(carName(a)) + '</b></span><a class="is-main" href="' + esc(carUrl(a)) + '">Ver todas las piezas para tu ' + nm + '</a>';
    }
    host.parentNode.insertBefore(el, host);
  }

  /* ---------- Páginas de coche: sugerir guardarlo ---------- */
  function carPage() {
    var s = document.querySelector('.cx-gsug'); if (s) s.remove();
    if (!CFG.carPage) return;
    var map = { 'piezas-nissan-s13': { b: 'Nissan', m: 'Silvia', g: 'S13' }, 'piezas-nissan-s14': { b: 'Nissan', m: 'Silvia', g: 'S14' }, 'piezas-nissan-s15': { b: 'Nissan', m: 'Silvia', g: 'S15' }, 'piezas-nissan-350z': { b: 'Nissan', m: '350Z', g: '' }, 'piezas-nissan-skyline': { b: 'Nissan', m: 'Skyline', g: '' }, 'piezas-bmw-e30': { b: 'BMW', m: 'Serie 3', g: 'E30' }, 'piezas-bmw-e36': { b: 'BMW', m: 'Serie 3', g: 'E36' }, 'piezas-bmw-e46': { b: 'BMW', m: 'Serie 3', g: 'E46' }, 'piezas-bmw-m3-e92': { b: 'BMW', m: 'M3', g: 'E92' }, 'piezas-bmw-serie-1-e82-e87': { b: 'BMW', m: 'Serie 1', g: 'E87' }, 'piezas-toyota-gt86-subaru-brz': { b: 'Toyota', m: 'GT86', g: '' }, 'piezas-toyota-supra': { b: 'Toyota', m: 'Supra', g: '' }, 'piezas-mazda-mx5': { b: 'Mazda', m: 'MX-5', g: '' }, 'piezas-volkswagen-golf': { b: 'Volkswagen', m: 'Golf', g: '' }, 'piezas-honda-civic': { b: 'Honda', m: 'Civic', g: '' } };
    var c = map[CFG.carPage], host = document.querySelector('.cx-car__cta'); if (!c || !host) return;
    var d = load(), has = d.cars.some(function (x) { return pageFor(x) === CFG.carPage; });
    var el = document.createElement('div'); el.className = 'cx-gsug';
    if (has) { el.innerHTML = OK_SVG.replace('<svg', '<svg width="18" height="18" style="color:#5be33a"') + '<span>Este coche está en tu garaje.</span><button type="button" data-cxg-open>Mi garaje</button>'; }
    else { el.innerHTML = '<span>¿Es tu coche?</span><button type="button" data-cxg-addcar>Guardarlo en Mi garaje</button>'; el.querySelector('[data-cxg-addcar]').addEventListener('click', function () { add(c); }); }
    host.parentNode.insertBefore(el, host.nextSibling);
  }

  function refresh(changed) {
    if (!root.hidden) render();
    header(); product(); cards(); carPage();
    if (changed && CFG.coll) {
      try { sessionStorage.removeItem('cx_gar_off_' + CFG.coll.h); } catch (e) {}
      var u = new URL(location.href), had = false;
      ['marca', 'modelo', 'generacion'].forEach(function (k) { var pn = 'filter.p.m.compatibilidad.' + k; if (u.searchParams.has(pn)) { had = true; u.searchParams.delete(pn); } });
      if (had) location.replace(u.toString()); else location.reload();
      return;
    }
    listing();
    try { var a2 = active(); if (a2) localStorage.setItem('cx_car', JSON.stringify({ n: carName(a2), u: carUrl(a2) })); } catch (e) {}
  }
  window.CxGarageApp = { open: open, add: add, active: active, refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { refresh(false); }); else refresh(false);
  new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1 && (n.matches('.cx-card[data-cx-fit]') || n.querySelector && n.querySelector('.cx-card[data-cx-fit]'))) cards(n.parentNode || n); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(false); });
})();
